// @ts-nocheck
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const usePinPost = (profileId?: string) => {
  const [isPinning, setIsPinning] = useState(false);

  const pinPost = async (postId: string): Promise<boolean> => {
    if (!profileId) {
      toast.error('You must be logged in to pin posts');
      return false;
    }

    setIsPinning(true);
    try {
      const { error } = await supabase.rpc('pin_post', {
        p_post_id: postId,
        p_profile_id: profileId,
      });

      if (error) throw error;

      toast.success('Post pinned to your profile!');
      return true;
    } catch (error: any) {
      console.error('Error pinning post:', error);
      toast.error(error.message || 'Failed to pin post');
      return false;
    } finally {
      setIsPinning(false);
    }
  };

  const unpinPost = async (postId: string): Promise<boolean> => {
    if (!profileId) {
      toast.error('You must be logged in to unpin posts');
      return false;
    }

    setIsPinning(true);
    try {
      const { error } = await supabase.rpc('unpin_post', {
        p_post_id: postId,
        p_profile_id: profileId,
      });

      if (error) throw error;

      toast.success('Post unpinned from your profile');
      return true;
    } catch (error: any) {
      console.error('Error unpinning post:', error);
      toast.error(error.message || 'Failed to unpin post');
      return false;
    } finally {
      setIsPinning(false);
    }
  };

  return {
    pinPost,
    unpinPost,
    isPinning,
  };
};
